import { useMutation as u, useQuery as r } from "@tanstack/react-query";
import { aX as i, a$ as a, j as c, a7 as y, ae as q, aW as p, a_ as m, R as C, s as f, N as v, aP as x, a as d, d as K, g as F, G as l, H as L, a6 as G, a1 as E, ai as g, Z as A, am as P, a8 as R, ad as Q, af as T, r as S, $ as h, ah as w, aj as N, as as M, aQ as D, aO as U, aE as j, aS as O, b0 as z, b1 as B, aZ as I, S as k, U as V, V as X, X as Z, aY as $, aV as s, aU as o, aT as H, e as W, ak as Y, p as _, b3 as J, b2 as b, Q as ee, aR as te, w as ne, y as re, A as ue, B as se, M as oe, ab as ie, f as ae, a2 as ce, aF as ye, D as qe, P as pe } from "./services.gen-72h9jWK3.js";
import { u as yn } from "./useCreateConversationReview-CX3jha91.js";
function _e(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => i(n),
      ...e
    })
  };
}
function Je(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => a(n),
      ...e
    })
  };
}
function be(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => c(n),
      ...e
    })
  };
}
function et(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => y(n),
      ...e
    })
  };
}
function tt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => q(n),
      ...e
    })
  };
}
function nt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => p(n),
      ...e
    })
  };
}
function rt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => m(n),
      ...e
    })
  };
}
function ut(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => C(n),
      ...e
    })
  };
}
function st(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => f(n),
      ...e
    })
  };
}
function ot(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => v(n),
      ...e
    })
  };
}
function it(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => x(n),
      ...e
    })
  };
}
const me = () => ["accountList"];
function at(e) {
  return {
    ...r({
      queryKey: me(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => d(),
      ...e
    })
  };
}
function ct(e) {
  return {
    ...r({
      queryKey: ["accountAccountsList"],
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => K(),
      ...e
    })
  };
}
function yt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => F(n),
      ...e
    })
  };
}
function Ce() {
  return ["authSocialList"];
}
function qt(e) {
  return {
    ...r({
      queryKey: Ce(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => l(),
      ...e
    })
  };
}
function pt(e) {
  return {
    ...r({
      queryKey: ["authTestList"],
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => L(),
      cacheTime: 0,
      ...e
    })
  };
}
function fe(e) {
  return ["conversationApplicationConversationRead", e];
}
function mt(e, t) {
  return {
    ...r({
      queryKey: fe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => G(e),
      ...t
    })
  };
}
function ve(e) {
  return ["conversationAdminConversationsRead", e];
}
function Ct(e, t) {
  return {
    ...r({
      queryKey: ve(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => E(e),
      ...t
    })
  };
}
function xe(e) {
  return ["conversationCouncilConversationsRead", e];
}
function ft(e, t) {
  return {
    ...r({
      queryKey: xe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => g(e),
      ...t
    })
  };
}
function de(e) {
  return ["conversationAdminConversationsRead", e];
}
function vt(e, t) {
  return {
    ...r({
      queryKey: de(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => A(e),
      ...t
    })
  };
}
function Ke(e) {
  return ["conversationMessagesGraph", e];
}
function xt(e, t) {
  return {
    ...r({
      queryKey: Ke(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => P(e),
      ...t
    })
  };
}
function Fe(e) {
  return [
    "conversationApplicationConversationMessagesList",
    e
  ];
}
function dt(e, t) {
  return {
    ...r({
      queryKey: Fe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => R(e),
      ...t
    })
  };
}
function le(e) {
  return ["conversationConversationsNotesList", e];
}
function Kt(e, t) {
  return {
    ...r({
      queryKey: le(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Q(e),
      ...t
    })
  };
}
function Le(e) {
  return ["conversationConversationsReviewsList", e];
}
function Ft(e, t) {
  return {
    ...r({
      queryKey: Le(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => T(e),
      ...t
    })
  };
}
function Ge(e) {
  return [
    "assessmentConversationAssessmentReviewStatesList",
    e
  ];
}
function lt(e, t) {
  return {
    ...r({
      queryKey: Ge(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => S(e),
      ...t
    })
  };
}
function Ee(e) {
  return ["conversationAdminConversationsList", e];
}
function Lt(e, t) {
  return {
    ...r({
      queryKey: Ee(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => h(e),
      ...t
    })
  };
}
function ge(e) {
  return ["conversationCouncilConversationsList", e];
}
function Gt(e, t) {
  return {
    ...r({
      queryKey: ge(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => w(e),
      ...t
    })
  };
}
function Ae(e) {
  return ["conversationPanelsList", e];
}
function Et(e, t) {
  return {
    ...r({
      queryKey: Ae(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => N(e),
      ...t
    })
  };
}
function Pe(e) {
  return ["councilCouncilsList", e];
}
function gt(e, t) {
  return {
    ...r({
      queryKey: Pe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => M(e),
      ...t
    })
  };
}
function Re(e) {
  return ["expertExpertRead", e];
}
function At(e, t) {
  return {
    ...r({
      queryKey: Re(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => D(e),
      ...t
    })
  };
}
function Qe() {
  return ["expertExpertConfigTypesList"];
}
function Pt(e) {
  return {
    ...r({
      queryKey: Qe(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => U(),
      ...e
    })
  };
}
function Te(e) {
  return ["expertContextCuttersList", e];
}
function Rt(e, t) {
  return {
    ...r({
      queryKey: Te(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => j(e),
      ...t
    })
  };
}
function Se(e) {
  return ["expertPanelsList", e];
}
function Qt(e, t) {
  return {
    ...r({
      queryKey: Se(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => O(e),
      ...t
    })
  };
}
function he(e) {
  return ["expertPanelsRead", e];
}
function Tt(e, t) {
  return {
    ...r({
      queryKey: he(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => z(e),
      ...t
    })
  };
}
function we(e) {
  return ["expertPanelsRead", e];
}
function St(e, t) {
  return {
    ...r({
      queryKey: we(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => B(e),
      ...t
    })
  };
}
function Ne(e) {
  return ["expertPanelsList", e];
}
function ht(e, t) {
  return {
    ...r({
      queryKey: Ne(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => I(e),
      ...t
    })
  };
}
function Me(e) {
  return ["conversationAdminConversationTestPanelRead", e];
}
function wt(e, t) {
  return {
    ...r({
      queryKey: Me(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => k(e),
      ...t
    })
  };
}
function De(e) {
  return [
    "conversationAdminConversationTestPanelResultsList",
    e
  ];
}
function Nt(e, t) {
  return {
    ...r({
      queryKey: De(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => V(e),
      ...t
    })
  };
}
function Ue(e) {
  return [
    "conversationAdminConversationTestPanelResultsGroupedList",
    e
  ];
}
function Mt(e, t) {
  return {
    ...r({
      queryKey: Ue(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => X(
        e
      ),
      ...t
    })
  };
}
function je(e) {
  return ["conversationAdminConversationTestPanelsList", e];
}
function Dt(e, t) {
  return {
    ...r({
      queryKey: je(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Z(e),
      ...t
    })
  };
}
function Oe(e) {
  return ["expertLlmProvidersList", e];
}
function Ut(e, t) {
  return {
    ...r({
      queryKey: Oe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => $(e),
      ...t
    })
  };
}
function ze(e) {
  return ["expertExpertsList", e];
}
function jt(e, t) {
  return {
    ...r({
      queryKey: ze(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => s(e),
      ...t
    })
  };
}
function Be(e) {
  return ["expertExpertsListList", e];
}
function Ot(e, t) {
  return {
    ...r({
      queryKey: Be(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => o(e),
      ...t
    })
  };
}
function Ie(e) {
  return ["expertExpertsGroupedList", e];
}
function zt(e, t) {
  return {
    ...r({
      queryKey: Ie(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => H(e),
      ...t
    })
  };
}
function ke(e) {
  return ["addressAddressNearObjectsRead", e];
}
function Bt(e, t) {
  return {
    ...r({
      queryKey: ke(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => W(e),
      ...t
    })
  };
}
function Ve(e) {
  return ["conversationPublicConversationRead", e];
}
function It(e, t) {
  return {
    ...r({
      queryKey: Ve(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Y(e),
      ...t
    })
  };
}
function Xe(e) {
  return ["assessmentAssessmentReviewStateDefinitionList", e];
}
function kt(e, t) {
  return {
    ...r({
      queryKey: Xe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => _(e),
      ...t
    })
  };
}
function Ze(e) {
  return ["getSchemaByName", e];
}
function Vt(e, t) {
  return {
    ...r({
      queryKey: Ze(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => J(e),
      ...t
    })
  };
}
function $e() {
  return ["schemasList"];
}
function Xt(e) {
  return {
    ...r({
      queryKey: $e(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => b(),
      ...e
    })
  };
}
function He(e) {
  return ["conversationAdminConversationTestGroupsList", e];
}
function Zt(e, t) {
  return {
    ...r({
      queryKey: He(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => ee(e),
      ...t
    })
  };
}
function $t(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => te(n),
      ...e
    })
  };
}
function Ht(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => s(n),
      ...e
    })
  };
}
function Wt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => o(n),
      ...e
    })
  };
}
function Yt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ne(n),
      ...e
    })
  };
}
function _t(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: () => re(),
      ...e
    })
  };
}
function Jt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ue(n),
      ...e
    })
  };
}
function bt(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => se(n),
      ...e
    })
  };
}
function en(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => oe(
        n
      ),
      ...e
    })
  };
}
function tn(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ie(n),
      ...e
    })
  };
}
function nn(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ae(n),
      ...e
    })
  };
}
function rn(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ce(n),
      ...e
    })
  };
}
function un(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ye(n),
      ...e
    })
  };
}
function sn(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => qe(n),
      ...e
    })
  };
}
function on(e) {
  return {
    ...u({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => pe(n),
      ...e
    })
  };
}
export {
  me as getAccountQueryKey,
  Ce as getAuthSocialListQueryKey,
  ve as getConversationAsAdminQueryKey,
  xe as getConversationAsCouncilQueryKey,
  de as getConversationExpertResultsQueryKey,
  Ke as getConversationMessageGraphQueryKey,
  Fe as getConversationMessagesQueryKey,
  le as getConversationNotesQueryKey,
  Ae as getConversationPanelsQueryKey,
  fe as getConversationQueryKey,
  Ge as getConversationReviewStatesQueryKey,
  Le as getConversationReviewsQueryKey,
  Ee as getConversationsAsAdminQueryKey,
  ge as getCouncilConversationsQueryKey,
  Pe as getCouncilsQueryKey,
  Qe as getExpertConfigTypesQueryKey,
  Te as getExpertContextCuttersQueryKey,
  Se as getExpertInputsFromConversationQueryKey,
  we as getExpertPanelGraphQueryKey,
  he as getExpertPanelQueryKey,
  Me as getExpertPanelTestQueryKey,
  Ue as getExpertPanelTestResultsGroupedQueryKey,
  De as getExpertPanelTestResultsQueryKey,
  je as getExpertPanelTestsQueryKey,
  Ne as getExpertPanelsQueryKey,
  Oe as getExpertProvidersQueryKey,
  Re as getExpertQueryKey,
  Be as getExpertsListQueryKey,
  ze as getExpertsQueryKey,
  Ie as getGroupedExpertsQueryKey,
  ke as getObjectsNearAddressQueryKey,
  Ve as getPublicConversationQueryKey,
  Xe as getReviewStateFieldDefinitionsQueryKey,
  Ze as getSchemaQueryKey,
  $e as getSchemasQueryKey,
  He as getTestGroupsQueryKey,
  _e as useArchiveExpert,
  Je as useArchiveExpertPanel,
  be as useCreateApplication,
  et as useCreateConversationMessage,
  tt as useCreateConversationNote,
  yn as useCreateConversationReview,
  st as useCreateConversationReviewState,
  nt as useCreateExpert,
  rt as useCreateExpertPanel,
  ut as useCreateExpertPanelTest,
  ot as useCreateTestGroup,
  it as useExecuteExpertDraft,
  at as useGetAccount,
  ct as useGetAccounts,
  yt as useGetAddressSuggestions,
  qt as useGetAuthSocialList,
  pt as useGetAuthTest,
  mt as useGetConversation,
  Ct as useGetConversationAsAdmin,
  ft as useGetConversationAsCouncil,
  vt as useGetConversationExpertResults,
  xt as useGetConversationMessageGraph,
  dt as useGetConversationMessages,
  Kt as useGetConversationNotes,
  Et as useGetConversationPanels,
  lt as useGetConversationReviewStates,
  Ft as useGetConversationReviews,
  Lt as useGetConversationsAsAdmin,
  Gt as useGetCouncilConversations,
  gt as useGetCouncils,
  At as useGetExpert,
  Pt as useGetExpertConfigTypes,
  Rt as useGetExpertContextCutters,
  Qt as useGetExpertInputsFromConversation,
  Tt as useGetExpertPanel,
  St as useGetExpertPanelGraph,
  wt as useGetExpertPanelTest,
  Nt as useGetExpertPanelTestResults,
  Mt as useGetExpertPanelTestResultsGrouped,
  Dt as useGetExpertPanelTests,
  ht as useGetExpertPanels,
  Ut as useGetExpertProviders,
  jt as useGetExperts,
  Ot as useGetExpertsList,
  zt as useGetGroupedExperts,
  Bt as useGetObjectsNearAddress,
  It as useGetPublicConversation,
  kt as useGetReviewStateFieldDefinitions,
  Vt as useGetSchema,
  Xt as useGetSchemas,
  Zt as useGetTestGroups,
  $t as useLazyGetExpertFullPrompt,
  Ht as useLazyGetExperts,
  Wt as useLazyGetExpertsList,
  Yt as useLogin,
  _t as useLogout,
  Jt as usePasswordReset,
  bt as usePasswordResetConfirm,
  en as useRateConversationExpertResult,
  tn as useSaveReport,
  nn as useSelectAddress,
  rn as useSendConversationToCouncil,
  un as useSetDefaultPanel,
  sn as useSignUp,
  on as useUpdateTestGroup
};
//# sourceMappingURL=apiHooks.js.map
